<template>
  <div>
    <div class="mt-2" v-for="field in values" :key="field.Id">
      <!-- <pre class="language-json"><code>{{ field  }}</code></pre> -->
      <form-fill-field
        :checklist="checklist"
        :value="field"
        :modelstate="modelstate"
        :fieldId="field.fieldId"
        :token="token"
      />

      <sub-checklist-fill-field
        :checklist="checklist"
        :values="getAditionalFields(field)"
        :modelstate="modelstate"
        :token="token"
      ></sub-checklist-fill-field>
    </div>
  </div>
</template>
<script>
export default {
  name: "SubChecklistFillField",
  props: {
    values: Array,
    modelstate: Object,
    autosaveValues: Array,
    checklist: Object,
    token: {
      description: "Token de acesso",
      type: String,
      required: true
    }
  },
  components: {
    FormFillField: () =>
      import("@/components_rms/checklist/form/FormFillField.vue"),
    SubChecklistFillField: () =>
      import(
        "@/components_rms/checklist/form/subForm/SubChecklistFillField.vue"
      ),
  },
  methods: {
    getAditionalFields(field) {
      let fields = [];
      if (field.value != null) {
        if (field.options != null) {
          for (let opt of field.options) {
            if (opt.value == field.value) {
              if (opt.additional != null) {
                for (let aditionalField of opt.additional) {
                  fields.push(aditionalField);
                }
              }
            }
          }
        }
      }
      return fields;
    },
  },
};
</script>
